import { ScreenProfilePassword } from '@dms/screen'

export default ScreenProfilePassword
